module.exports = __webpack_public_path__ + "media/Cs.81cfbc72.wav";